import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './style.css';
import { connect } from 'react-redux';
import { intersection } from 'lodash';
import { actions } from './reducers';
import { filter, orderBy } from 'lodash';
import { FormattedMessage, injectIntl, intlShape, defineMessages } from 'react-intl';
import Banner from './components/banner/';
import LinkItem from './components/LinkItem/';
import { COMPANY_ID_DIOR } from 'configs/company';
import {
  functions,
} from 'configs';
import {
  toggleOnboardingProcess,
} from 'containers/App/reducers/applicationReducer';
import {
  setMessage,
  resetMessage,
  setErrorMessage,
} from 'containers/App/reducers/messageReducer';
import CompanyCustomizeProvider from 'components/CompanyCustomizeProvider';
import onboardingProcessIcon from './images/links/tube/icon_onboarding_process.svg';
import thirdPartyIcon from './images/links/ta/third_party.png';
import mayoFormIcon from './images/links/mayoform/mayo-form.png';
import CustomReportIcon from './images/links/tube/custom-report.svg';
import RedirectItem from 'containers/App/screens/MayoForm/components/LinkItem';
import url from 'configs/url';
import modules from 'configs/modules';
import axios from 'axios';
import { setCookie } from 'utils/cookie';

const messages = defineMessages({
  settingTooltip: {
    id: 'SH_Setting',
    defaultMessage: '設定',
  },
});

class IndexPage extends Component {
  constructor(props) {
    super(props);
    this.showGuideMessage = this.showGuideMessage.bind(this);
  }

  componentWillMount() {
    this.props.fetchCarouselSecond();
    this.props.fetchBanners();
    this.props.startLinkCountTimer();
  }

  componentWillUnmount() {
    this.props.stopLinkCountTimer();
  }

  showGuideMessage() {
    const {
      application: {
        isShowOnboardingProcess,
      },
    } = this.props;
    this.props.setMessage(
      [<FormattedMessage
        key="1"
        id="SH_Message"
        defaultMessage="訊息"
      />],
      [isShowOnboardingProcess ? <FormattedMessage id="SH_UseGuideOffConfirm" defaultMessage="將關閉常用流程引導" /> : <FormattedMessage id="SH_UseGuideOnConfirm" defaultMessage="將開啟常用流程引導" />],
      () => {
        this.props.toggleOnboardingProcess({
          enable: !isShowOnboardingProcess,
        });
        this.props.resetMessage();
      },
      this.props.resetMessage,
      '#008BCD',
      this.props.resetMessage
    );
  }
  renderRecommendedFeatures() {
    const features = [];
    const {
      displayCommonProcessesGuideSwitch,
      isShowThirdParty,
      isShowMAYOForm,
      isCustomReportAdmin,
    } = this.props;
    if (displayCommonProcessesGuideSwitch) {
      features.push(
        <LinkItem
          onClick={this.showGuideMessage}
          icon={onboardingProcessIcon}
          i18nKey="SH_UseGuide"
          defaultMessage="常用流程引導"
        />
      );
    }
    if (isShowThirdParty) {
      features.push(
        <LinkItem
          url="/ta/personal/third-party"
          icon={thirdPartyIcon}
          i18nKey="SH_ThirdPartyIntegration"
          defaultMessage="第三方服務整合"
        />
      );
    }

    if (isShowMAYOForm) {
      features.push(
        <LinkItem
          icon={mayoFormIcon}
          i18nKey="NOKEY"
          defaultMessage="MAYO Form"
          onClick={() => {
            // 同步XE所選語系到新站台並開啟新站
            setCookie(
              'locale',
              sessionStorage.getItem('locale') || 'zh-TW',
              undefined,
              '.mayohr.com'
            );
            window.open(modules.MAYOForm.rootUrl, '_blank');
          }}
        />
      );
    }

    if (isCustomReportAdmin) {
      features.push(
        <RedirectItem
          icon={CustomReportIcon}
          text={<FormattedMessage id="SH_MayoReport" defaultMessage="自定義報表" />}
          getRedirectUrl={() => {
            // 同步XE所選語系到新站台
            setCookie(
              'locale',
              sessionStorage.getItem('locale') || 'zh-TW',
              undefined,
              '.mayohr.com'
            );
            return axios.get(`${url.WEBBFF_API_SERVER}CustomizedReport/RedirectUrl`)
            .then(() => window.open(`${url.NEW_XE}/custom-report`, '_blank'))
            .catch((error) => {
              this.props.setErrorMessage({
                confirmReload: error.response.data.code === 500 || error.response.data.code === 403,
                httpStatus: 500,
                message: error.response.data.exception,
              });
            });
          }

          }
        />
      );
    }
    if (features.length > 0) {
      return (
        <div>
          <div className="page-title">
            <h1 className="page-title__text">
              <FormattedMessage id="SH_FeatureRecommendations" defaultMessage="推薦功能" />
            </h1>
          </div>
          <ul className="list-group">{features}</ul>
        </div>
      );
    }
    return <span/>;
  }
  render() {
    const {
      application: {
        companyId,
      },
      user: {
        functionRole: {
          isBannerAdministrator,
        },
        allowModules,
        isSupervisor,
      },
      index: {
        banners,
        links,
      },
    } = this.props;
    let availableLinks = Object.values(links.data);
    availableLinks = filter(availableLinks, (link) => {
      return allowModules.indexOf(link.module) >= 0 && (link.onlySupervisor === false || isSupervisor);
    });
    availableLinks = orderBy(availableLinks, ['sort']);
    return (
      <div className="container">
        <Banner
          showSetting={isBannerAdministrator}
          settingTooltip={this.props.intl.formatMessage(messages.settingTooltip)}
          carouselSecond={banners.carouselSecond}
          banners={banners.data}
          {...banners}
        />
        {this.renderRecommendedFeatures()}
        <div className="page-title">
          <h1 className="page-title__text">
            <FormattedMessage id="FD_MyShortcuts" defaultMessage="我的快捷" />
          </h1>
        </div>
        <ul className="list-group">
        {
          availableLinks.map((link) => {
            return (
              <CompanyCustomizeProvider
                companyId={companyId}
                companyCustomizeIdArray={COMPANY_ID_DIOR}
                render={(renderData) => {
                  // Dior公司 > 排除訂餐功能Icon
                  if (renderData.isCompanyCustomize && link.i18nKey === 'FD_NewOrder') {
                    return null;
                  }
                  return <LinkItem {...link} key={link.id}/>;
                }}
              />
            );
          })
        }
        </ul>
      </div>
    );
  }
}

IndexPage.propTypes = {
  application: PropTypes.object,
  user: PropTypes.object.isRequired,
  index: PropTypes.shape({
    banners: PropTypes.object.isRequired,
    links: PropTypes.object.isRequired,
  }),
  fetchBanners: PropTypes.func.isRequired,
  fetchCarouselSecond: PropTypes.func.isRequired,
  startLinkCountTimer: PropTypes.func.isRequired,
  stopLinkCountTimer: PropTypes.func.isRequired,
  toggleOnboardingProcess: PropTypes.func,
  displayCommonProcessesGuideSwitch: PropTypes.bool,
  isShowThirdParty: PropTypes.bool,
  isShowMAYOForm: PropTypes.bool,
  isCustomReportAdmin: PropTypes.bool,
  setMessage: PropTypes.func,
  resetMessage: PropTypes.func,
  setErrorMessage: PropTypes.func,
  intl: intlShape.isRequired,
};

function mapStateToProps(state) {
  const { functionSetting } = state.app.application;
  const { userRole } = state.app.user;
  return {
    index: state.app.tube.index,
    user: state.app.user,
    application: state.app.application,
    displayCommonProcessesGuideSwitch: intersection(userRole, functions.standardProcessesByRoles).length > 0,
    isShowThirdParty: (functionSetting.datas.find(v => v.functionCode === functions.googleCalendar) || {}).enable,
    isShowMAYOForm: (functionSetting.datas.find(v => v.functionCode === functions.mayoForm) || {}).enable,
    isCustomReportAdmin: userRole.some(role => role === 'CustomReportAdmin'),
  };
}

IndexPage = connect(mapStateToProps, Object.assign({}, actions, { toggleOnboardingProcess, setMessage, resetMessage, setErrorMessage }))(injectIntl(IndexPage));

export default IndexPage;



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Tube/screens/Index/index.js
 **/